import { render, staticRenderFns } from "./representiveForm.vue?vue&type=template&id=446542ec&"
import script from "./representiveForm.vue?vue&type=script&lang=js&"
export * from "./representiveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports